module.exports = __webpack_public_path__ + "img/dashboard-dark2.15f3afdf.webp";